import React from 'react';
import { PlaysGridRowManager } from 'services/PlaysGridRowManager';
import { observer } from 'mobx-react-lite';
import { ISession } from 'interfaces/session/ISession';
import { GridView } from '../GridView/GridView';
import { BatterViewWrapper } from './styles/BatterViewStyles';
import { batterToCombinedBoxScoreData } from '../helpers/playerMappingHelper';

interface IProps {
  rowManager: PlaysGridRowManager;
  session: ISession;
  isAwayTeam: boolean;
  isLoading: boolean;
}
export const BatterView: React.FC<IProps> = observer((props) => {
  const { rowManager, isAwayTeam, isLoading } = props;
  const { trackmanBoxScore, secondSourceBoxScore } = rowManager.boxScoreManager;

  const onBatterSelected = (isChecked: boolean, batterId: string) => {
    isChecked ? rowManager.boxScoreManager.selectBatter(batterId) : rowManager.boxScoreManager.deselectBatter(batterId);
  };

  const awayTeamData = trackmanBoxScore.awayTeam.batting.map((player) =>
    batterToCombinedBoxScoreData(player, secondSourceBoxScore.awayTeam.batting)
  );
  const homeTeamData = trackmanBoxScore.homeTeam.batting.map((player) =>
    batterToCombinedBoxScoreData(player, secondSourceBoxScore.homeTeam.batting)
  );

  return (
    <BatterViewWrapper>
      <GridView
        data={isAwayTeam ? awayTeamData : homeTeamData}
        isPitcherView={false}
        selectedIds={rowManager.boxScoreManager.selectedBatterIds}
        onPlayerSelectionChange={onBatterSelected}
        discrepancies={isAwayTeam ? rowManager.boxScoreManager.awayBatterDiscrepancies : rowManager.boxScoreManager.homeBatterDiscrepancies}
        isLoading={isLoading}
      />
    </BatterViewWrapper>
  );
});
